export enum FlagAcesso {
  Ler      = (1 << 0),
  Inserir  = (1 << 1)  + Ler,
  Alterar  = (1 << 2)  + Ler,
  Excluir  = (1 << 3)  + Alterar,
  Executar = (1 << 4)  + Alterar + Ler,
  Exportar = (1 << 12) + Ler,
  Imprimir = (1 << 13) + Ler
}
